import React from 'react'
import { ToastContainer } from 'react-toastify'

export default function PublicLayout({children}) {
  return (
    <div className='container public-container bg-img mx-0'>
        {children}
        <ToastContainer />
    </div>
  )
}
